export const BreakStatement = {
  print: () => 'break;'
};
